module.exports = __webpack_public_path__ + "videos/optimised/af6bc42b19b64e02c587b07ec0c64a7b.mp4";